<section class="py-24">

  <div class="w-11/12 mx-auto">

    <h2 class="text-4xl font-light mb-14">
      Executive Summary
    </h2>

    <div class="grid md:grid-cols-3 gap-10">

      <div class="bg-primary-100 p-10 rounded-xl">

        <h3 class="text-xl mb-4 text-blue-900 font-medium">
          GCC Delivery Model
        </h3>

        <p class="text-gray-700">
          CIC operates as a centralized Global Capability Center
          providing engineering expertise and platform governance.
        </p>

      </div>

      <div class="bg-primary-100 p-10 rounded-xl">

        <h3 class="text-xl mb-4 text-indigo-900 font-medium">
          Single Delivery Engine
        </h3>

        <p class="text-gray-700">
          A unified offshore engine supporting Build, Run,
          and Modernize initiatives.
        </p>

      </div>

      <div class="bg-primary-100 p-10 rounded-xl">

        <h3 class="text-xl mb-4 text-sky-900 font-medium">
          Platform Ownership
        </h3>

        <p class="text-gray-700">
          Product-led delivery enabling platform ownership,
          reuse, and long-term scalability.
        </p>

      </div>

    </div>

  </div>

</section>